export default __webpack_public_path__ + "static/media/888.9a96b964.png";